import type {
  AdminSetPasswordBody,
  CreateUserBody,
  CreateUserResponse,
  ListUsersResponse,
  SetUserActiveBody,
  SetUserActiveResponse,
  UpdateUserRoleBody,
  UpdateUserRoleResponse,
} from '@movo/contracts/api/users';
import apiClient from '@/shared/lib/apiClient';
import type { UsersListParams } from '../model/users';

type UserId = { id: string };

const withoutEmpty = (params: UsersListParams) =>
  Object.fromEntries(Object.entries(params).filter(([, value]) => value !== ''));

/** `GET /api/users`: la pagina richiesta e il totale degli utenti che rispettano i filtri. */
export async function fetchUsers(params: UsersListParams) {
  const res = await apiClient.get<ListUsersResponse>('/users', { params: withoutEmpty(params) });
  const { items, total } = res.data.data;
  return { items, total };
}

export async function createUser(payload: CreateUserBody) {
  const res = await apiClient.post<CreateUserResponse>('/users', payload);
  return res.data.data;
}

export async function changeUserRole({ id, role }: UserId & UpdateUserRoleBody) {
  const res = await apiClient.patch<UpdateUserRoleResponse>(`/users/${id}/role`, { role });
  return res.data.data;
}

export async function setUserActive({ id, isActive }: UserId & SetUserActiveBody) {
  const res = await apiClient.patch<SetUserActiveResponse>(`/users/${id}/status`, { isActive });
  return res.data.data;
}

export async function setUserPassword({ id, newPassword }: UserId & AdminSetPasswordBody) {
  await apiClient.patch(`/users/${id}/reset-password`, { newPassword });
}

export async function deleteUser(id: string) {
  await apiClient.delete(`/users/${id}`);
}
